import { v4 as uuid } from 'uuid';
import { MortgageDocumentType } from './MortgageDocumentType';

export interface IRecordedMortgage {
  mortgagor_name: string | null;
  lender_name: string | null;
  trustee_name: string | null;
  document_type: MortgageDocumentType | null;
  other_document_type: string | null;
  original_loan_amount: number | null;
  id: string;
  instrument_number: string | null;
  book: string | null;
  execution_date: string | null;
  maturity_date: string | null;
  recorded_date: string | null;
  recorded_at: string | null;
}

export interface IRecordedMortgageRequired {
  mortgagor_name: boolean;
  lender_name: boolean;
  trustee_name: boolean;
  document_type: boolean;
  other_document_type: boolean;
  original_loan_amount: boolean;
  instrument_number: boolean;
  book: boolean;
  execution_date: boolean;
  maturity_date: boolean;
  recorded_date: boolean;
  recorded_at: boolean;
}

export const constructNewRecordedMortgage = ({
  id = uuid(),
  instrument_number = null,
  book = null,
  recorded_date = null,
  recorded_at = null,
  mortgagor_name = null,
  lender_name = null,
  trustee_name = null,
  other_document_type = null,
  original_loan_amount = null,
  execution_date = null,
  maturity_date = null,
  document_type = null,
}: Partial<IRecordedMortgage> = {}) => ({
  id,
  instrument_number,
  book,
  recorded_date,
  recorded_at,
  mortgagor_name,
  lender_name,
  trustee_name,
  other_document_type,
  original_loan_amount,
  execution_date,
  maturity_date,
  document_type,
});
